import { Flex, Select, Input, Button, Text } from '@chakra-ui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const schema = z.object({
  mes: z.string().nonempty('O Mês é obrigatório!'),
  ano: z.string().nonempty('O Ano é obrigatório!'),
  numeroPedido: z.string().optional(),
  empresa: z.string().optional(),
})

export function Filtros({ onSubmit, isLoading, objectMonth, years, enterprises }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    resolver: zodResolver(schema),
  })

  useEffect(() => {
    const defaultMonth = new Date().getMonth() + 1
    const defaultMonthString = defaultMonth.toString().padStart(2, '0')
    const defaultYearString = new Date().getFullYear().toString()

    setValue('ano', defaultYearString)
    setValue('mes', defaultMonthString)
  }, [setValue])

  return (
    <>
      <Flex as="form" onSubmit={handleSubmit(onSubmit)} alignItems="end" justifyContent="center" gap={2}>
        <Select maxW="150px" size="sm" {...register('mes')} id="mes">
          <option value="">Mês</option>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((item, index) => (
            <option key={index} value={item < 10 ? `0${item}` : item}>
              {objectMonth[item]}
            </option>
          ))}
        </Select>

        <Select maxW="150px" size="sm" {...register('ano')} id="ano">
          <option value="">Ano</option>
          {years.map((year, index) => (
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </Select>

        <Flex flexDir="column">
          <Text as="label" fontSize="sm" htmlFor="numero-pedido">
            Número do Pedido
          </Text>
          <Input {...register('numeroPedido')} size="sm" id="numero-pedido" />
        </Flex>

        <Flex flexDir="column">
          <Text as="label" fontSize="sm" htmlFor="empresa">
            Empresa
          </Text>
          <Select {...register('empresa')} size="sm" id="empresa">
            <option value="">Todas</option>
            {enterprises.map((enterprise) => (
              <option key={enterprise.id} value={enterprise.codigo_empresa}>
                {enterprise.nome_empresa}
              </option>
            ))}
          </Select>
        </Flex>

        <Button isLoading={isLoading} loadingText="Buscando..." size="sm" colorScheme="blue" ml="4" maxW="120px" w="full" type="submit">
          Buscar
        </Button>
      </Flex>

      {errors.ano && (
        <Text size="xs" color="red.500">
          {errors.ano.message}
        </Text>
      )}
      {errors.mes && (
        <Text size="xs" color="red.500">
          {errors.mes.message}
        </Text>
      )}
    </>
  )
}
